import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProInvestorLayout from "../components/Sections/ProInvestorLayout";

const ProInvestor = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubscription = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Call your Firebase function
    const response = await fetch(
      "https://payment-func.netlify.app/.netlify/functions/createSubscription",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          planId: "plan_QKSVH2uBLsciPz",
          customerEmail: formData.email,
        }),
      }
    );
    const { subscriptionId } = await response.json();

    // Now open Razorpay Checkout
    const options = {
      key: "rzp_test_RVOVO4L6J32rvj",
      subscription_id: subscriptionId,
      name: formData.name,
      email: formData.email,
      handler: function (response) {
        alert("Payment successful! Subscription ID: " + subscriptionId);
      },
      theme: { color: "#3399cc" },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
    setIsLoading(false);
  };

  return (
    <div className="mt-20">
      <ProInvestorLayout
        showModal={showModal}
        setShowModal={setShowModal}
        isLoading={isLoading}
        formData={formData}
        handleInputChange={handleInputChange}
        handleSubscription={handleSubscription}
      />
    </div>
  );
};

export default ProInvestor;
